/* SundayBazar Smart Filter - fast client-side filtering for big collections */
(function () {
  'use strict';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var LS_TTL = 12 * 3600 * 1000;   // show cached list instantly for up to 12h
  var FRESH = 3 * 60 * 1000;       // older than 3 min -> refresh silently in background
  var CONCURRENCY = 10;
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) {
    try { localStorage.setItem(k, v); return true; } catch (e) {
      try { Object.keys(localStorage).forEach(function (x) { if (x.indexOf('sbsf') === 0 && x !== k) localStorage.removeItem(x); }); localStorage.setItem(k, v); return true; } catch (e2) { return false; }
    }
  }
  function pack(rows) {
    var pfx = '';
    for (var i = 0; i < rows.length; i++) if (rows[i][11]) { var u = rows[i][11], j = u.indexOf('/files/'); if (j > 0) pfx = u.slice(0, j + 7); break; }
    var out = rows.map(function (r) {
      var c = r.slice();
      if (pfx) { [11, 12].forEach(function (k) { if (c[k] && c[k].indexOf(pfx) === 0) c[k] = '~' + c[k].slice(pfx.length); }); }
      return c;
    });
    return JSON.stringify({ t: Date.now(), p: pfx, rows: out });
  }
  function unpack(s) {
    var o = JSON.parse(s), p = o.p || '';
    o.rows.forEach(function (r) { [11, 12].forEach(function (k) { if (r[k] && r[k].charAt(0) === '~') r[k] = p + r[k].slice(1); }); });
    return o;
  }
  var COND_ORDER = ['like new', 'brand new', 'leftover', 'premium', 'excellent', 'very good', 'v.good', 'v. good', 'good', 'fair'];
  var COLORS = {
    black: '#111', white: '#fff', 'off white': '#f3efe6', offwhite: '#f3efe6', cream: '#f3e9d2', beige: '#d9c7a5', nude: '#e3bc9a', tan: '#c19a6b',
    brown: '#7a4b2a', camel: '#b5835a', khaki: '#a89f6b', grey: '#9a9a9a', gray: '#9a9a9a', silver: '#c9c9c9', gold: '#d4af37', golden: '#d4af37',
    red: '#d0021b', maroon: '#7b1e2b', burgundy: '#7b1e2b', pink: '#f2a7c3', 'hot pink': '#ff3e8f', purple: '#7b3fa0', lilac: '#c8a2c8',
    blue: '#2f5fd0', navy: '#1f2a4d', 'sky blue': '#87ceeb', green: '#2e8b57', olive: '#6b6b2a', mint: '#a8e6cf', yellow: '#f5d000',
    orange: '#f28c28', mustard: '#d4a017', peach: '#ffcba4', multi: 'conic-gradient(#f33,#fc3,#3c6,#39f,#c3f,#f33)', 'multi color': 'conic-gradient(#f33,#fc3,#3c6,#39f,#c3f,#f33)',
    multicolor: 'conic-gradient(#f33,#fc3,#3c6,#39f,#c3f,#f33)', transparent: 'repeating-conic-gradient(#ddd 0 25%,#fff 0 50%) 0 0/8px 8px', clear: 'repeating-conic-gradient(#ddd 0 25%,#fff 0 50%) 0 0/8px 8px'
  };
  /* filter order on mobile and desktop: Size, Color, Condition, Product type, Brand, Discount, Price, Gender */
  var FACETS = [
    { key: 'size', label: 'Size', kind: 'size' },
    { key: 'color', label: 'Color', kind: 'color', limit: 12 },
    { key: 'cond', label: 'Condition', kind: 'cond' },
    { key: 'type', label: 'Product type', limit: 10 },
    { key: 'brand', label: 'Brand', limit: 10, search: true },
    { key: 'disc', label: 'Discount', kind: 'disc' },
    { key: 'g', label: 'Gender' }
  ];
  var COMPAT = {
    'filter.v.option.size': 'size', 'filter.v.option.condition': 'cond', 'filter.v.option.color': 'color', 'filter.v.option.colour': 'color',
    'filter.p.vendor': 'brand', 'filter.p.product_type': 'type'
  };
  var HIDE_BRANDS = { 'sundaybazar': 1, 'sunday bazar': 1, 'n/a': 1, 'na': 1, 'european brand': 1, 'unbranded': 1 };
  var SORT_COMPAT = { 'price-ascending': 'price-asc', 'price-descending': 'price-desc', 'created-descending': 'newest', 'manual': 'featured', 'best-selling': 'featured' };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(n, cur) { return cur + Math.round(n).toLocaleString('en-US'); }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }
  /* one clean size format everywhere: "Euro 38" (fixes 38 / EU 38 / Eur.38 / Eruo 38 / Euro-38, splits 38-39) */
  function normSizes(list) {
    var out = [];
    list.forEach(function (v) {
      var s = String(v).trim(), m;
      m = /^(?:euro?|eruo|eur|eu)?[\s.:\-]*(\d{2})\s*[-\/]\s*(\d{2})$/i.exec(s);
      if (m) { [m[1], m[2]].forEach(function (n) { n = +n; if (n >= 15 && n <= 50) out.push('Euro ' + n); }); return; }
      m = /^(?:euro?|eruo|eur|eu)?[\s.:\-]*(\d{2}(?:[.,]5)?)$/i.exec(s);
      if (m) { var n = parseFloat(m[1].replace(',', '.')); if (n >= 15 && n <= 50) { out.push('Euro ' + n); return; } }
      out.push(s);
    });
    return out.filter(function (v, i) { return v && out.indexOf(v) === i; });
  }
  function sizeKey(s) {
    var m = /^(.*?)[\s-]*(\d+(?:[.,]\d+)?)\s*([a-z]*)$/i.exec(String(s).trim());
    if (!m) return { group: 'Other', num: 9999, label: s };
    return { group: (m[1] || 'Size').trim() || 'Size', num: parseFloat(m[2].replace(',', '.')), label: m[2] + (m[3] ? ' ' + m[3] : '') };
  }

  function init(root) {
    var handle = root.getAttribute('data-handle');
    var total = parseInt(root.getAttribute('data-total'), 10) || 0;
    var cur = root.getAttribute('data-currency') || 'Rs.';
    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 24;
    var version = root.getAttribute('data-version') || '';
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var grid = $('[data-sf-grid]'), facetsEl = $('[data-sf-facets]'), chipsEl = $('[data-sf-chips]');
    var countEl = $('[data-sf-count]'), emptyEl = $('[data-sf-empty]'), moreEl = $('[data-sf-more]');
    var qEl = $('[data-sf-q]'), sortEl = $('[data-sf-sort]'), progEl = $('[data-sf-progress]');
    var quickEl = $('[data-sf-quick]'), quickRow = $('[data-sf-quick-row]');

    var pgN = 0, pgDone = 0;
    function pctNow() { return pgN ? Math.round(pgDone * 100 / pgN) : Math.min(100, Math.round(loadedCount * 100 / Math.max(total, 1))); }
    var items = [], loaded = false, loadedCount = 0, results = [], shown = perPage, facetValues = {}, built = false;
    var state = { sel: {}, min: null, max: null, sale: false, off: null, q: '', sort: 'featured', cat: [] };  // cat = category picked from the round icons (kept out of the filter list)
    var OFFS = [10, 20, 30, 40, 50, 60, 70, 80];
    FACETS.forEach(function (f) { state.sel[f.key] = new Set(); });

    /* ---------- URL state ---------- */
    function readUrl() {
      var sp = new URLSearchParams(location.search);
      sp.forEach(function (val, key) {
        var k = COMPAT[key] || key;
        if (state.sel[k]) { String(val).split(',').forEach(function (v) { v = v.trim(); if (v) state.sel[k].add(v); }); }
      });
      var mn = sp.get('min') || sp.get('filter.v.price.gte'), mx = sp.get('max') || sp.get('filter.v.price.lte');
      state.min = mn ? parseFloat(mn) : null; state.max = mx ? parseFloat(mx) : null;
      state.sale = sp.get('sale') === '1';
      var ov = parseInt(sp.get('off'), 10); state.off = OFFS.indexOf(ov) >= 0 ? ov : null;
      state.q = sp.get('q') || '';
      state.cat = (sp.get('cat') || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean);
      var so = sp.get('sort') || SORT_COMPAT[sp.get('sort_by')] || 'featured';
      state.sort = /^(featured|newest|price-asc|price-desc|discount)$/.test(so) ? so : 'featured';
      qEl.value = state.q; sortEl.value = state.sort;
    }
    function writeUrl() {
      var sp = new URLSearchParams(location.search);
      Array.from(sp.keys()).forEach(function (k) {
        if (state.sel[k] || COMPAT[k] || /^(min|max|sale|off|q|sort|sort_by|page|cat)$/.test(k) || k.indexOf('filter.') === 0) sp.delete(k);
      });
      FACETS.forEach(function (f) { state.sel[f.key].forEach(function (v) { sp.append(f.key, v); }); });
      if (state.min != null) sp.set('min', state.min);
      if (state.max != null) sp.set('max', state.max);
      if (state.sale) sp.set('sale', '1');
      if (state.off) sp.set('off', state.off);
      if (state.q) sp.set('q', state.q);
      if (state.cat.length) sp.set('cat', state.cat.join('|'));
      if (state.sort !== 'featured') sp.set('sort', state.sort);
      var qs = sp.toString();
      try { history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : '') + location.hash); } catch (e) {}
    }

    /* ---------- data ---------- */
    function toItem(a, ord) {
      var p = a[5], c = a[6] > p ? a[6] : 0;
      var it = {
        id: a[0], h: a[1], t: a[2], brand: a[3] || '', type: a[4] || '', p: p, c: c,
        size: a[7] ? normSizes(a[7].split('|').filter(Boolean)) : [], cond: a[8] || '', color: a[9] || '',
        g: a[10] ? a[10].split('|').filter(Boolean) : [], i1: a[11] || '', i2: a[12] || '', cr: a[13] || 0,
        off: c ? Math.round((c - p) * 100 / c) : 0, ord: ord, vid: a[14] || 0, nav: a[15] == null ? 1 : a[15]
      };
      var db = Math.round(it.off / 10) * 10;
      it.v = { disc: db > 0 ? [db + '% Off'] : [], type: it.type ? [it.type] : [], size: it.size, cond: it.cond ? [it.cond] : [], brand: it.brand && !HIDE_BRANDS[it.brand.toLowerCase()] ? [it.brand] : [], color: it.color ? [it.color] : [], g: it.g };
      it.s = (it.t + ' ' + it.brand + ' ' + it.type + ' ' + it.color + ' ' + it.cond + ' ' + it.size.join(' ')).toLowerCase();
      return it;
    }
    function feedUrl(page) { return ROOT + 'collections/' + encodeURIComponent(handle) + '?view=sbfeed&filter.v.availability=1&page=' + page; }
    function fetchPage(page) {
      return fetch(feedUrl(page), { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status); return r.text();
      }).then(function (t) { return JSON.parse(t); });
    }
    function load() {
      try { Object.keys(localStorage).forEach(function (x) { if (x.indexOf('sbsf2:') === 0) localStorage.removeItem(x); }); } catch (e) {}
      var key = 'sbsf3:' + handle, cached = null, s = lsGet(key);
      if (s) { try { cached = unpack(s); } catch (e) { cached = null; } }
      if (cached && cached.rows && cached.rows.length && Date.now() - cached.t < LS_TTL) {
        ingest(cached.rows, true);                       // instant: filters + products from this device's saved copy
        if (Date.now() - cached.t > FRESH) fetchAll(true, function (rows, failed) { if (!failed) { replaceAll(rows); lsSet(key, pack(rows)); } });
        return;
      }
      fetchAll(false, function (rows, failed) { if (!failed) lsSet(key, pack(rows)); });
    }
    function fetchAll(silent, done) {
      var pages = [], n = 1, next = 2, active = 0, finished = 1, upTo = 1, failed = false;
      fetchPage(1).then(function (d) {
        pages[1] = d.items || []; n = d.pages || 1; if (!silent) { pgN = n; pgDone = 1; }
        if (!silent) ingest(pages[1], false);
        if (n <= 1) return finish();
        pump();
      }).catch(function () {
        if (!silent) { countEl.textContent = 'Could not load products. Please refresh the page.'; progEl.classList.add('is-done'); }
      });
      function pump() { while (active < CONCURRENCY && next <= n) get(next++); }
      function get(pg) {
        active++;
        var tries = 0;
        (function attempt() {
          fetchPage(pg).then(function (dd) { pages[pg] = dd.items || []; settle(); })
            .catch(function () { if (++tries < 3) setTimeout(attempt, 700 * tries); else { pages[pg] = []; failed = true; settle(); } });
        })();
      }
      function settle() { active--; finished++; if (!silent) pgDone = finished; if (!silent) ingestOrdered(); if (finished === n) finish(); else pump(); }
      function ingestOrdered() {
        var batch = [];
        while (pages[upTo + 1] !== undefined) { upTo++; batch = batch.concat(pages[upTo]); }
        if (batch.length) ingest(batch, false);
      }
      function finish() {
        var all = [];
        for (var i = 1; i <= n; i++) all = all.concat(pages[i] || []);
        if (!silent) { ingestOrdered(); loaded = true; afterLoad(); }
        done(all, failed);
      }
    }
    function replaceAll(rows) {
      items = [];
      var seen = {};
      rows.forEach(function (a) { if (!seen[a[0]]) { seen[a[0]] = 1; items.push(toItem(a, items.length)); } });
      loadedCount = items.length;
      buildFacets();
      update(false);
    }
    var facetTimer = null;
    function ingest(rows, complete) {
      var seen = {};
      items.forEach(function (it) { seen[it.id] = 1; });
      rows.forEach(function (a) { if (!seen[a[0]]) { seen[a[0]] = 1; items.push(toItem(a, items.length)); } });
      loadedCount = items.length;
      if (complete) { loaded = true; afterLoad(); return; }
      var pct = pctNow();
      progEl.firstElementChild.style.width = pct + '%';
      update(false);
      // filters are usable straight away; refresh their values as more products arrive
      if (!built) buildFacets();
      else if (!facetTimer) facetTimer = setTimeout(function () { facetTimer = null; if (!loaded) buildFacets(); }, 600);
    }
    function afterLoad() {
      progEl.classList.add('is-done');
      buildFacets();
      var pos = null;
      try { pos = JSON.parse(ss('sbsf:pos:' + location.pathname + location.search) || 'null'); } catch (e) {}
      if (pos && pos.shown) shown = Math.max(perPage, pos.shown);
      update(false);
      if (pos && pos.y) { requestAnimationFrame(function () { window.scrollTo(0, pos.y); }); ss('sbsf:pos:' + location.pathname + location.search, null); }
    }

    /* ---------- filtering ---------- */
    function passes(it, skip) {
      for (var i = 0; i < FACETS.length; i++) {
        var k = FACETS[i].key; if (k === skip) continue;
        var sel = state.sel[k]; if (!sel.size) continue;
        var vals = it.v[k], ok = false;
        for (var j = 0; j < vals.length; j++) if (sel.has(vals[j])) { ok = true; break; }
        if (!ok) return false;
      }
      if (state.cat.length && skip !== 'type' && skip !== 'cat' && state.cat.indexOf(it.type) < 0) return false;
      if (skip !== 'price') {
        if (state.min != null && it.p < state.min) return false;
        if (state.max != null && it.p > state.max) return false;
      }
      if (skip !== 'sale' && state.sale && !it.off) return false;
      if (skip !== 'sale' && state.off && it.off < state.off) return false;
      if (state.q) { var words = state.q.toLowerCase().split(/\s+/); for (var w = 0; w < words.length; w++) if (words[w] && it.s.indexOf(words[w]) < 0) return false; }
      return true;
    }
    function sortItems(arr) {
      var s = state.sort, f, g;
      if (s === 'newest') f = function (a, b) { return b.cr - a.cr || a.ord - b.ord; };
      else if (s === 'price-asc') f = function (a, b) { return a.p - b.p || a.ord - b.ord; };
      else if (s === 'price-desc') f = function (a, b) { return b.p - a.p || a.ord - b.ord; };
      else if (s === 'discount') f = function (a, b) { return b.off - a.off || a.ord - b.ord; };
      else f = function (a, b) { return a.ord - b.ord; };
      g = function (a, b) { return ((a.nav === 0) - (b.nav === 0)) || f(a, b); };  // sold-out pairs always last
      return arr.sort(g);
    }
    function activeCount() {
      var n = 0; FACETS.forEach(function (f) { n += state.sel[f.key].size; });
      if (state.min != null || state.max != null) n++; if (state.sale) n++; if (state.off) n++; return n;
    }

    /* ---------- facets UI ---------- */
    function collectValues() {
      FACETS.forEach(function (f) { facetValues[f.key] = {}; });
      items.forEach(function (it) { if (it.nav === 0) return; FACETS.forEach(function (f) { it.v[f.key].forEach(function (v) { facetValues[f.key][v] = (facetValues[f.key][v] || 0) + 1; }); }); });
      FACETS.forEach(function (f) { state.sel[f.key].forEach(function (v) { if (!facetValues[f.key][v]) facetValues[f.key][v] = 0; }); });
    }
    function orderedValues(f) {
      var vals = Object.keys(facetValues[f.key]);
      if (f.kind === 'size') return vals.sort(function (a, b) { var A = sizeKey(a), B = sizeKey(b); return A.group === B.group ? A.num - B.num : A.group.localeCompare(B.group); });
      if (f.kind === 'disc') return vals.sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
      if (f.kind === 'cond') return vals.sort(function (a, b) {
        var ia = COND_ORDER.indexOf(a.toLowerCase()), ib = COND_ORDER.indexOf(b.toLowerCase());
        return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib) || a.localeCompare(b);
      });
      if (f.key === 'brand' || f.key === 'type') { var fv = facetValues[f.key]; return vals.sort(function (a, b) { return (fv[b] - fv[a]) || a.localeCompare(b); }); }  // most stock first
      return vals.sort(function (a, b) { return a.localeCompare(b); });
    }
    function buildFacets() {
      // remember what the shopper had open / typed so a refresh never disturbs them
      var prev = {}, act = document.activeElement, actSel = null, actPos = 0;
      facetsEl.querySelectorAll('details[data-facet]').forEach(function (d) {
        var fs = d.querySelector('[data-fsearch]');
        prev[d.getAttribute('data-facet')] = { open: d.open, exp: d.hasAttribute('data-expanded'), q: fs ? fs.value : '' };
      });
      if (act && facetsEl.contains(act)) {
        var dd = act.closest('details[data-facet]');
        actSel = dd ? '[data-facet="' + dd.getAttribute('data-facet') + '"] ' + (act.hasAttribute('data-min') ? '[data-min]' : act.hasAttribute('data-max') ? '[data-max]' : act.hasAttribute('data-fsearch') ? '[data-fsearch]' : '') : null;
        try { actPos = act.selectionStart; } catch (e) {}
      }
      var scrollA = facetsEl.scrollTop, panel = root.querySelector('.sbsf-panel'), scrollB = panel ? panel.scrollTop : 0;
      collectValues();
      var html = '', chunks = {}, OPEN = { size: 1, cond: 1, type: 1 };
      var saleOpt = '<label class="sbsf-opt"><input type="checkbox" data-sale><span class="sbsf-box"></span><span>On sale only</span><span class="n" data-n-sale></span></label>';
      FACETS.forEach(function (f, fi) {
        var vals = orderedValues(f);
        if (vals.length < 2 && !state.sel[f.key].size) return;
        var wasOpen = prev[f.key] ? prev[f.key].open : (OPEN[f.key] || state.sel[f.key].size > 0);
        var open = wasOpen ? ' open' : '';
        html = '';
        html += '<details class="sbsf-facet" data-facet="' + f.key + '"' + open + '><summary>' + esc(f.label) + '<em data-sel-n></em></summary><div class="sbsf-fbody">';
        if (f.kind === 'size') {
          var lastG = null, groups = {};
          vals.forEach(function (v) { groups[sizeKey(v).group] = 1; });
          var multi = Object.keys(groups).length > 1;
          vals.forEach(function (v) {
            var k = sizeKey(v);
            if (k.group !== lastG) { if (lastG !== null) html += '</div>'; if (multi) html += '<div class="sbsf-sizegroup">' + esc(k.group) + '</div>'; html += '<div class="sbsf-sizes">'; lastG = k.group; }
            html += '<button type="button" class="sbsf-size" data-k="size" data-v="' + esc(v) + '" aria-pressed="false" title="' + esc(v) + '">' + esc(multi ? k.label : v) + '</button>';
          });
          if (lastG !== null) html += '</div>';
        } else {
          if (f.search) html += '<input type="search" class="sbsf-fsearch" data-fsearch placeholder="Search ' + esc(f.label.toLowerCase()) + '" aria-label="Search ' + esc(f.label) + '">';
          html += '<div class="sbsf-list">';
          if (f.key === 'disc') html += saleOpt;
          vals.forEach(function (v) {
            var dot = f.kind === 'color' ? '<span class="sbsf-dot" style="background:' + (COLORS[v.toLowerCase()] || '#ccc') + '"></span>' : '';
            html += '<label class="sbsf-opt" data-v="' + esc(v) + '"><input type="checkbox" data-k="' + f.key + '" value="' + esc(v) + '"><span class="sbsf-box"></span>' + dot + '<span>' + esc(v) + '</span><span class="n" data-n></span></label>';
          });
          html += '</div>';
          if (f.limit && vals.length > f.limit) html += '<button type="button" class="sbsf-showmore" data-more>Show all ' + vals.length + '</button>';
        }
        html += '</div></details>';
        chunks[f.key] = html;
      });
      html = '';
      // price
      var priceOpen = (prev.price ? prev.price.open : (state.min != null || state.max != null)) ? ' open' : '';
      html = '<details class="sbsf-facet" data-facet="price"' + priceOpen + '><summary>Price<em data-sel-n></em></summary><div class="sbsf-fbody">' +
        '<div class="sbsf-prange"><label>' + esc(cur) + '<input type="number" inputmode="numeric" min="0" placeholder="Min" data-min aria-label="Minimum price"></label><span>–</span>' +
        '<label>' + esc(cur) + '<input type="number" inputmode="numeric" min="0" placeholder="Max" data-max aria-label="Maximum price"></label></div>' +
        '<div class="sbsf-presets">' +
        [[null, 1999, 'Under 2,000'], [2000, 3999, '2,000 – 4,000'], [4000, 5999, '4,000 – 6,000'], [6000, null, '6,000+']].map(function (r) {
          return '<button type="button" class="sbsf-pill" data-preset="' + (r[0] == null ? '' : r[0]) + ',' + (r[1] == null ? '' : r[1]) + '" aria-pressed="false">' + r[2] + '</button>';
        }).join('') + '</div></div></details>';
      chunks.price = html;
      if (!chunks.disc) chunks.disc = '<details class="sbsf-facet" data-facet="sale"' + ((prev.sale ? prev.sale.open : (state.sale || state.off)) ? ' open' : '') + '><summary>Discount<em data-sel-n></em></summary><div class="sbsf-fbody"><div class="sbsf-list">' + saleOpt + '</div></div></details>';
      html = ['size', 'color', 'cond', 'type', 'brand', 'disc', 'price', 'g'].map(function (k) { return chunks[k] || ''; }).join('');
      facetsEl.innerHTML = html;
      Object.keys(prev).forEach(function (k) {
        var d = facetsEl.querySelector('details[data-facet="' + k + '"]'); if (!d) return;
        if (prev[k].exp) { d.setAttribute('data-expanded', ''); var b = d.querySelector('[data-more]'); if (b) b.remove(); }
        var fs = d.querySelector('[data-fsearch]');
        if (fs && prev[k].q) { fs.value = prev[k].q; filterFacetList(fs); }
      });
      built = true;
      updateFacetUI();
      if (actSel) { var el = facetsEl.querySelector(actSel); if (el) { el.focus(); try { el.setSelectionRange(actPos, actPos); } catch (e) {} } }
      facetsEl.scrollTop = scrollA; if (panel) panel.scrollTop = scrollB;
      buildQuick();
    }
    function filterFacetList(t) {
      var q = t.value.trim().toLowerCase(), d = t.closest('details');
      if (q) { d.setAttribute('data-expanded', ''); var b = d.querySelector('[data-more]'); if (b) b.remove(); }
      d.querySelectorAll('.sbsf-opt').forEach(function (o) { o.hidden = q ? o.getAttribute('data-v').toLowerCase().indexOf(q) < 0 : false; });
      if (!q) { d.removeAttribute('data-expanded'); applyLimits(); }
    }
    function applyLimits() {
      FACETS.forEach(function (f) {
        if (!f.limit) return;
        var d = facetsEl.querySelector('[data-facet="' + f.key + '"]'); if (!d || d.hasAttribute('data-expanded')) return;
        var opts = d.querySelectorAll('.sbsf-opt'), shownN = 0;
        // keep selected + most popular visible
        var counts = Array.prototype.map.call(opts, function (o) { return { o: o, n: parseInt(o.getAttribute('data-count') || '0', 10), sel: o.querySelector('input').checked }; });
        var ranked = counts.slice().sort(function (a, b) { return (b.sel - a.sel) || (b.n - a.n); });
        var keep = new Set(ranked.slice(0, f.limit).map(function (x) { return x.o; }));
        counts.forEach(function (x) { x.o.hidden = !keep.has(x.o) && !x.sel; if (!x.o.hidden) shownN++; });
      });
    }
    function buildQuick() {
      var vals = facetValues.size ? orderedValues(FACETS[0]) : [];
      if (!vals.length) { quickEl.hidden = true; return; }
      var groups = {};
      vals.forEach(function (v) { var g = sizeKey(v).group; groups[g] = (groups[g] || 0) + 1; });
      var main = Object.keys(groups).sort(function (a, b) { return groups[b] - groups[a]; })[0];
      var whole = vals.filter(function (v) { var k = sizeKey(v); return k.group === main && Math.floor(k.num) === k.num; });
      if (whole.length < 3) whole = vals.filter(function (v) { return sizeKey(v).group === main; });
      var cnt = {};
      items.forEach(function (it) { it.size.forEach(function (v) { cnt[v] = (cnt[v] || 0) + 1; }); });
      if (whole.length > 12) {
        var top = whole.slice().sort(function (a, b) { return (cnt[b] || 0) - (cnt[a] || 0); }).slice(0, 12);
        whole = whole.filter(function (v) { return top.indexOf(v) >= 0; });
      }
      quickRow.innerHTML = whole.map(function (v) { return '<button type="button" class="sbsf-pill" data-quick="' + esc(v) + '" aria-pressed="false">' + esc(v) + '</button>'; }).join('');
      quickEl.hidden = false;
    }
    function updateFacetUI() {
      if (!built) return;
      FACETS.forEach(function (f) {
        var d = facetsEl.querySelector('[data-facet="' + f.key + '"]'); if (!d) return;
        var counts = {};
        items.forEach(function (it) { if (passes(it, f.key)) it.v[f.key].forEach(function (v) { counts[v] = (counts[v] || 0) + 1; }); });
        d.querySelectorAll('[data-v]').forEach(function (el) {
          var v = el.getAttribute('data-v'), n = counts[v] || 0, sel = state.sel[f.key].has(v);
          el.setAttribute('data-count', n);
          var nEl = el.querySelector('[data-n]'); if (nEl) nEl.textContent = n;
          if (f.kind === 'size') { el.setAttribute('aria-pressed', sel); el.disabled = !n && !sel; }
          else { el.querySelector('input').checked = sel; el.classList.toggle('is-zero', !n && !sel); }
        });
        var sn = d.querySelector('[data-sel-n]'); sn.textContent = state.sel[f.key].size ? state.sel[f.key].size + ' selected' : '';
      });
      var pd = facetsEl.querySelector('[data-facet="price"]');
      if (pd) {
        var mi = pd.querySelector('[data-min]'), ma = pd.querySelector('[data-max]');
        if (document.activeElement !== mi) mi.value = state.min != null ? state.min : '';
        if (document.activeElement !== ma) ma.value = state.max != null ? state.max : '';
        pd.querySelectorAll('[data-preset]').forEach(function (b) {
          var r = b.getAttribute('data-preset').split(',');
          var on = String(state.min == null ? '' : state.min) === r[0] && String(state.max == null ? '' : state.max) === r[1];
          b.setAttribute('aria-pressed', on);
        });
        pd.querySelector('[data-sel-n]').textContent = (state.min != null || state.max != null) ? priceLabel() : '';
      }
      var sIn = facetsEl.querySelector('[data-sale]'), sd = sIn ? sIn.closest('details') : null;
      if (sd) {
        sIn.checked = state.sale;
        var sc = 0; items.forEach(function (it) { if (it.off && passes(it, 'sale')) sc++; });
        sd.querySelector('[data-n-sale]').textContent = sc;
        var sx = state.off ? state.off + '%+ off' : state.sale ? 'On sale' : '', sn2 = sd.querySelector('[data-sel-n]');
        if (sd.getAttribute('data-facet') === 'sale') sn2.textContent = sx;
        else if (sx) sn2.textContent = sn2.textContent ? sn2.textContent + ', ' + sx : sx;
      }
      quickRow.querySelectorAll('[data-quick]').forEach(function (b) { b.setAttribute('aria-pressed', state.sel.size.has(b.getAttribute('data-quick'))); });
      applyLimits();
    }
    function priceLabel() {
      if (state.min != null && state.max != null) return money(state.min, cur) + ' – ' + money(state.max, cur);
      if (state.min != null) return money(state.min, cur) + '+';
      return 'Under ' + money(state.max + 1, cur);
    }
    function renderChips() {
      var html = '';
      FACETS.forEach(function (f) { state.sel[f.key].forEach(function (v) { html += '<button type="button" class="sbsf-chip" data-chip="' + f.key + '" data-v="' + esc(v) + '"><b>' + esc(f.label) + ':</b> ' + esc(v) + ' <span aria-hidden="true">&times;</span></button>'; }); });
      if (state.min != null || state.max != null) html += '<button type="button" class="sbsf-chip" data-chip="price"><b>Price:</b> ' + esc(priceLabel()) + ' <span aria-hidden="true">&times;</span></button>';
      if (state.sale) html += '<button type="button" class="sbsf-chip" data-chip="sale">On sale <span aria-hidden="true">&times;</span></button>';
      if (state.off) html += '<button type="button" class="sbsf-chip" data-chip="off"><b>Discount:</b> ' + state.off + '%+ off <span aria-hidden="true">&times;</span></button>';
      if (state.q) html += '<button type="button" class="sbsf-chip" data-chip="q"><b>Search:</b> ' + esc(state.q) + ' <span aria-hidden="true">&times;</span></button>';
      if (html) html += '<button type="button" class="sbsf-chip sbsf-chip-clear" data-sf-clear>Clear all</button>';
      chipsEl.innerHTML = html; chipsEl.hidden = !html;
      var n = activeCount();
      $$('[data-sf-nact]').forEach(function (b) { b.textContent = n; b.hidden = !n; });
    }

    /* ---------- grid ---------- */
    function card(it, i) {
      var img = it.i1 ? '<img src="' + esc(it.i1) + '" alt="' + esc(it.t) + '" loading="' + (i < 4 ? 'eager' : 'lazy') + '" width="540" height="540">' : '';
      var img2 = it.i2 ? '<img class="h" src="' + esc(it.i2) + '" alt="" loading="lazy" width="540" height="540">' : '';
      var meta = (it.size.length > 1 ? '<i>Multiple sizes</i>' : it.size[0] ? '<i>' + esc(it.size[0]) + '</i>' : '') + (it.cond ? '<i>' + esc(it.cond) + '</i>' : '');
      var url = ROOT + 'products/' + encodeURIComponent(it.h);
      var atc = '';
      if (it.vid && it.nav === 1) {
        atc = '<form method="post" action="' + ROOT + 'cart/add" accept-charset="UTF-8" class="sbsf-form" novalidate="novalidate">' +
          '<input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">' +
          '<input type="hidden" name="id" value="' + it.vid + '"><input type="hidden" name="quantity" value="1">' +
          '<button type="submit" class="sbsf-atc">Add to cart</button></form>';
      } else if (it.nav > 1) {
        atc = '<a class="sbsf-atc" href="' + url + '">Choose size</a>';
      } else if (it.nav === 0) {
        atc = '<span class="sbsf-atc is-sold">Sold out</span>';
      }
      return '<div class="sbsf-card"><a class="sbsf-link" href="' + url + '">' +
        '<div class="sbsf-img">' + img + img2 + (it.off ? '<span class="sbsf-off">-' + it.off + '%</span>' : '') + '</div>' +
        '<div class="sbsf-info"><span class="sbsf-name">' + esc(it.t) + '</span>' +
        (meta ? '<span class="sbsf-meta">' + meta + '</span>' : '') +
        '<span class="sbsf-price"><b>' + money(it.p, cur) + '</b>' + (it.off ? '<s>' + money(it.c, cur) + '</s>' : '') + '</span></div></a>' + atc + '</div>';
    }
    function renderGrid() {
      var slice = results.slice(0, shown), html = '';
      for (var i = 0; i < slice.length; i++) html += card(slice[i], i);
      grid.innerHTML = html;
      renderMore();
    }
    function appendMore() {
      if (shown >= results.length) return;
      var from = shown; shown = Math.min(results.length, shown + perPage);
      var html = ''; for (var i = from; i < shown; i++) html += card(results[i], i);
      grid.insertAdjacentHTML('beforeend', html);
      renderMore();
    }
    function renderMore() {
      var n = results.length, s = Math.min(shown, n);
      emptyEl.hidden = !(loaded && n === 0);
      moreEl.hidden = n === 0;
      $('[data-sf-shown]').textContent = 'Showing ' + s.toLocaleString('en-US') + ' of ' + n.toLocaleString('en-US') + (loaded ? '' : '+') + ' products';
      $('[data-sf-bar]').style.width = (n ? Math.round(s * 100 / n) : 0) + '%';
      $('[data-sf-loadmore]').hidden = s >= n;
    }

    /* ---------- update cycle ---------- */
    var firstData = true;
    function update(resetShown) {
      if (resetShown) shown = perPage;
      var prevIds = grid.__ids || '';
      results = sortItems(items.filter(function (it) { return passes(it); }));
      var n = results.length;
      var label = loaded ? n.toLocaleString('en-US') + ' product' + (n === 1 ? '' : 's') : n.toLocaleString('en-US') + ' products found · loading ' + pctNow() + '%';
      countEl.textContent = label;
      $$('[data-sf-show]').forEach(function (b) { b.textContent = loaded ? 'Show ' + n.toLocaleString('en-US') + ' products' : 'Show products'; });
      var ids = results.slice(0, shown).map(function (it) { return it.id; }).join(',');
      if (ids !== prevIds || resetShown || firstData) { renderGrid(); grid.__ids = ids; firstData = false; }
      else renderMore();
      renderChips();
      updateFacetUI();
    }
    function changed() {
      writeUrl(); update(true);
      if (!root.classList.contains('is-open')) {
        var top = grid.getBoundingClientRect().top + window.pageYOffset - 120;
        if (window.pageYOffset > top) window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    }
    function clearAll() {
      FACETS.forEach(function (f) { state.sel[f.key].clear(); });
      state.min = state.max = null; state.sale = false; state.off = null; state.q = ''; qEl.value = '';
      changed();
    }

    /* ---------- events ---------- */
    root.addEventListener('click', function (e) {
      var t = e.target.closest('button, a');
      if (!t || !root.contains(t)) return;
      if (t.matches('.sbsf-link, a.sbsf-atc')) { ss('sbsf:pos:' + location.pathname + location.search, JSON.stringify({ shown: shown, y: window.pageYOffset })); return; }
      if (t.hasAttribute('data-sf-clear')) { clearAll(); return; }
      if (t.hasAttribute('data-sf-open')) { openPanel(); return; }
      if (t.hasAttribute('data-sf-close')) { closePanel(); return; }
      if (t.hasAttribute('data-sf-loadmore')) { appendMore(); return; }
      if (t.classList.contains('sbsf-size')) { toggle('size', t.getAttribute('data-v')); return; }
      if (t.hasAttribute('data-quick')) { toggle('size', t.getAttribute('data-quick')); return; }
      if (t.hasAttribute('data-more')) {
        var d = t.closest('details'); d.setAttribute('data-expanded', '');
        d.querySelectorAll('.sbsf-opt').forEach(function (o) { o.hidden = false; }); t.remove(); return;
      }
      if (t.hasAttribute('data-off')) { var ov = +t.getAttribute('data-off'); state.off = state.off === ov ? null : ov; changed(); return; }
      if (t.hasAttribute('data-preset')) {
        var r = t.getAttribute('data-preset').split(',');
        var on = t.getAttribute('aria-pressed') === 'true';
        state.min = on || r[0] === '' ? null : +r[0]; state.max = on || r[1] === '' ? null : +r[1];
        changed(); return;
      }
      if (t.hasAttribute('data-chip')) {
        var k = t.getAttribute('data-chip');
        if (k === 'price') state.min = state.max = null;
        else if (k === 'sale') state.sale = false;
        else if (k === 'off') state.off = null;
        else if (k === 'q') { state.q = ''; qEl.value = ''; }
        else state.sel[k].delete(t.getAttribute('data-v'));
        changed();
      }
    });
    root.querySelector('.sbsf-scrim').addEventListener('click', closePanel);
    facetsEl.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('input[type=checkbox][data-k]')) { if (t.checked) state.sel[t.getAttribute('data-k')].add(t.value); else state.sel[t.getAttribute('data-k')].delete(t.value); changed(); }
      else if (t.hasAttribute('data-sale')) { state.sale = t.checked; changed(); }
      else if (t.hasAttribute('data-min') || t.hasAttribute('data-max')) applyPriceInputs();
    });
    var priceTimer;
    facetsEl.addEventListener('input', function (e) {
      var t = e.target;
      if (t.hasAttribute('data-fsearch')) filterFacetList(t);
      else if (t.hasAttribute('data-min') || t.hasAttribute('data-max')) { clearTimeout(priceTimer); priceTimer = setTimeout(applyPriceInputs, 700); }
    });
    function applyPriceInputs() {
      clearTimeout(priceTimer);
      var mi = facetsEl.querySelector('[data-min]').value, ma = facetsEl.querySelector('[data-max]').value;
      var nmi = mi === '' ? null : Math.max(0, +mi), nma = ma === '' ? null : Math.max(0, +ma);
      if (nmi != null && nma != null && nmi > nma) { var x = nmi; nmi = nma; nma = x; }
      if (nmi === state.min && nma === state.max) return;
      state.min = nmi; state.max = nma; changed();
    }
    // round category icons above the products: filter by category without filling the filter list
    document.addEventListener('sbsf:cat', function (e) {
      var t = (e.detail && e.detail.types) || [];
      state.cat = t.slice(); changed();
      root.dispatchEvent(new CustomEvent('sbsf:catchange', { bubbles: true }));
    });
    function toggle(k, v) { if (state.sel[k].has(v)) state.sel[k].delete(v); else state.sel[k].add(v); changed(); }
    var qTimer;
    qEl.addEventListener('input', function () { clearTimeout(qTimer); qTimer = setTimeout(function () { state.q = qEl.value.trim(); changed(); }, 250); });
    qEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); clearTimeout(qTimer); state.q = qEl.value.trim(); changed(); qEl.blur(); } });
    sortEl.addEventListener('change', function () { state.sort = sortEl.value; changed(); });

    var lastFocus = null;
    function openPanel() {
      lastFocus = document.activeElement;
      root.classList.add('is-open'); document.documentElement.classList.add('sbsf-lock');
      var x = root.querySelector('.sbsf-x'); if (x) setTimeout(function () { x.focus(); }, 50);
    }
    function closePanel() {
      if (!root.classList.contains('is-open')) return;
      root.classList.remove('is-open'); document.documentElement.classList.remove('sbsf-lock');
      var top = grid.getBoundingClientRect().top + window.pageYOffset - 120;
      if (window.pageYOffset > top) window.scrollTo({ top: Math.max(0, top) });
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });

    // infinite scroll
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { if (en[0].isIntersecting && items.length) appendMore(); }, { rootMargin: '900px 0px' }).observe($('[data-sf-sentinel]'));
      var tools = $('.sbsf-tools');
      new IntersectionObserver(function (en) { root.classList.toggle('show-fab', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(tools);
    }

    /* ---------- add to cart ---------- */
    var toast = document.createElement('div');
    toast.className = 'sbsf-toast'; toast.setAttribute('role', 'status'); toast.hidden = true;
    root.appendChild(toast);
    var toastTimer;
    function showToast(html, ok) {
      toast.innerHTML = html; toast.className = 'sbsf-toast' + (ok ? '' : ' is-err'); toast.hidden = false;
      clearTimeout(toastTimer); toastTimer = setTimeout(function () { toast.hidden = true; }, 5000);
    }
    function setBtn(btn, txt, cls) { btn.textContent = txt; btn.classList.remove('is-busy', 'is-done', 'is-err'); if (cls) btn.classList.add(cls); }
    function refreshCartCount() {
      return fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll('hdt-cart-count, [data-cart-count], .cart-count-bubble span').forEach(function (el) { el.textContent = c.item_count; });
        return c;
      }).catch(function () {});
    }
    root.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.classList || !form.classList.contains('sbsf-form')) return;
      e.preventDefault(); e.stopPropagation();
      var btn = form.querySelector('.sbsf-atc');
      if (btn.classList.contains('is-busy')) return;
      setBtn(btn, 'Adding…', 'is-busy');
      fetch(ROOT + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: +form.querySelector('[name=id]').value, quantity: 1 }] })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          setBtn(btn, 'Added ✓', 'is-done');
          refreshCartCount();
          ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (ev) { try { document.dispatchEvent(new CustomEvent(ev, { bubbles: true })); } catch (x) {} });
          showToast('<span>Added to cart</span><a href="' + ROOT + 'cart">View cart</a><a class="sbsf-toast-go" href="' + ROOT + 'checkout">Checkout</a>', true);
        })
        .catch(function (err) {
          var msg = (err && (err.description || err.message)) || 'Could not add. Please try again.';
          if (/sold out|already/i.test(msg)) msg = 'Sorry, this pair was just sold or is already in your cart.';
          setBtn(btn, 'Add to cart'); showToast('<span>' + esc(msg) + '</span>', false);
        });
    });

    // hide the theme's normal product grid (its filters do not work on big collections)
    (function hideThemeGrid() {
      var main = document.getElementById('MainContent') || root.parentNode;
      Array.prototype.forEach.call(main.querySelectorAll(':scope > .shopify-section, :scope > section'), function (sec) {
        if (sec.contains(root)) return;
        if (/main[-_]collection|product[-_]grid/i.test(sec.id) || sec.querySelector('#FacetFiltersForm, facet-filters-form, #ProductGridContainer, [id^="product-grid"]')) sec.style.display = 'none';
      });
    })();

    readUrl();
    if (activeCount() || state.q || state.sort !== 'featured') {
      grid.innerHTML = Array(8).join('<div class="sbsf-card sbsf-skel"><div class="sbsf-img"></div><div class="sbsf-info"><span style="width:40%"></span><span></span><span style="width:60%"></span></div></div>');
      renderChips();
    }
    load();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('.sbsf[data-handle]'), function (r) { if (!r.__sbsf) { r.__sbsf = 1; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
